export default __webpack_public_path__ + "static/email1-8a7da90db9bbc55afcab2c0e96c57672.gif";